<p-dialog
  header="There exists a validation"
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '40rem', maxWidth: '95vw' }"
  (onHide)="close()"
>
  @if (foundValidation$ | async; as validation) {
    @if (isThereValidation.is_published) {
      <div>
        There exists a published validation with exactly the same settings, run
        on {{ validation.start_time | date: dateFormat : timeZone }}. <br />
        You can run your own validation and wait for the results or you can use
        the existing one.<br />
        You can also close this window and change some settings.<br />
        What would you like to do?
      </div>
    }
    @if (isThereValidation.belongs_to_user && !isThereValidation.is_published) {
      <div>
        You have already run a validation with exactly the same settings on
        {{ validation.start_time | date: dateFormat : timeZone }}. <br />
        You can run it again or use the existing one. <br />
      </div>
    }
    @if (
      !isThereValidation.belongs_to_user && !isThereValidation.is_published
    ) {
      <div>
        There exists a validation with exactly the same settings, run on
        {{ validation.start_time | date: dateFormat : timeZone }}. <br />
        You can run your own validation and wait for the results or you can use
        the existing one.<br />
      </div>
    }
    <div class="buttons mt-4 flex gap-3 justify-content-end flex-wrap">
      <button
        pButton
        type="button"
        class="btn-action-large"
        label="See the existing validation"
        (click)="useAnExistingValidation(validation)"
      ></button>
      <button
        pButton
        type="button"
        class="btn-action-large"
        label="Run your own validation"
        (click)="runOwnValidation()"
      ></button>
    </div>
  }
</p-dialog>
